module.exports = __webpack_public_path__ + "img/thumbnails-19-sortable-list.42aeb618.png";